var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "tr",
    { staticClass: "concordance", class: { "foreign-hit": _vm.row.isForeign } },
    [
      _vm._l(_vm.cols.hitColumns, function (col) {
        return [
          col.field === "custom"
            ? _c(
                "td",
                {
                  key: col.key + col.field,
                  class: col.class,
                  style: col.style,
                },
                [
                  _c(
                    "a",
                    {
                      attrs: {
                        href: _vm.row.href,
                        title: _vm
                          .$t("results.table.goToHitInDocument")
                          .toString(),
                        target: "_blank",
                      },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.row.customHitInfo))]
                  ),
                ]
              )
            : col.field === "match" ||
              col.field === "after" ||
              col.field === "before" ||
              col.field === "annotation"
            ? _c("HitContext", {
                key: col.key,
                class: col.class,
                style: col.style,
                attrs: {
                  tag: "td",
                  data: _vm.row.context,
                  bold: col.field === "match",
                  highlight: col.field !== "annotation",
                  before: col.field === "before",
                  after: col.field === "after",
                  punct: col.field !== "annotation",
                  annotation: col.annotation.id,
                  html: _vm.info.html,
                  dir: _vm.row.dir,
                  hoverMatchInfos: _vm.hoverMatchInfos,
                },
                on: {
                  hover: function ($event) {
                    return _vm.$emit("hover", $event)
                  },
                  unhover: function ($event) {
                    return _vm.$emit("unhover")
                  },
                },
              })
            : col.field === "metadata"
            ? _c(
                "td",
                {
                  key: col.key + col.metadata.id,
                  class: col.class,
                  style: col.style,
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.row.doc.docInfo[col.metadata.id]?.join(", ") || ""
                    )
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.row.gloss_fields, function (field) {
            return _c(
              "td",
              {
                key: field.fieldName,
                class: col.class,
                staticStyle: { overflow: "visible" },
                style: col.style,
              },
              [
                _c("GlossField", {
                  attrs: {
                    fieldName: field.fieldName,
                    hit_first_word_id: _vm.row.hit_first_word_id,
                    hit_last_word_id: _vm.row.hit_last_word_id,
                    fieldDescription: field,
                    hitId: _vm.row.hit_id,
                  },
                }),
              ],
              1
            )
          }),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }